import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Dashboard from './pages/Dashboard/Dashboard';
import './App.css';
import Admin from './pages/admin';
import { useAuth, PrivateRoutes } from './components/ProtectedRoute/PrivateRoutes';
import { Button, Layout } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { Content, Footer, Header } from 'antd/es/layout/layout';
import HeaderComponent from './components/Header/HeaderComponent';
import { useEffect, useState } from 'react';
import NotFound from './pages/NotFound';
import UserPage from './pages/admin/UserPage';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import DepartmetPage from './pages/admin/DepartmetPage';
import DocumentHierarchy from './pages/admin/DocumentHierarchy';
import Navigation from './components/Navigation/Navigation';
import DocViewerPage from './pages/DocViewer/DocViewerPage';
import AllDocsPage from './pages/Docs/AllDocsPage';
import ProfilePage from './pages/Profile/ProfilePage';
import DocumentPage from './pages/admin/DocumentPage';
import { AppProvider, useAppContext } from './hooks/useAppContext';
import FooterComponent from './components/Footer/FooterComponent';
import FooterPage from './pages/admin/FooterPage';

function App() {

  return (
    <PrivateRoutes>
      <AppProvider>
        <LayoutGlobal />
      </AppProvider>
    </PrivateRoutes>
  );
}

export default App;


export const LayoutGlobal = () => {
  const { authState } = useAuth()
  // const [collapsed, setCollapsed] = useState(false);
  const { menuCollapsed, setMenuCollapsed, menu } = useAppContext()
  // const admin = () => {
  //   return ['ADMIN'].includes(authState?.position)
  // }
  // let width = window.innerWidth

  return (
    <Router>
      {
        authState?.authenticated &&
        (
          <Layout style={{ minHeight: '100vh', paddingTop: 10 }}>
            <Header style={{ backgroundColor: 'transparent', borderRadius: 15, paddingRight: 15, paddingLeft: 15 }}>
              <HeaderComponent style={{ backgroundColor: '#fbfbfb', borderRadius: 15 }} />
            </Header>
            <Layout style={{ paddingRight: 10, paddingLeft: 10, paddingTop: 10 }}>
              <Sider
                style={{ backgroundColor: 'transparent', minHeight: '100%' }}
                collapsible
                collapsed={menuCollapsed}
                onCollapse={(value) => setMenuCollapsed(value)}
                trigger={null}
                collapsedWidth={0}
                width={220}
              >
                <div style={{ backgroundColor: '#fbfbfb', borderRadius: 15, boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', }}>


                  {/* <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', height: 50, paddingRight: 5, paddingLeft: 15 }}>
                  <Button type='text' icon={menuCollapsed ? <MenuUnfoldOutlined style={{ fontSize: 20 }} /> : <MenuFoldOutlined style={{ fontSize: 20 }} />} onClick={() => setMenuCollapsed(!menuCollapsed)} />
                </div> */}
                 
                  {
                    !menuCollapsed &&
                    <Navigation />
                  }
                </div>
              </Sider>
              {/* <Layout> */}
                <Content style={{ paddingLeft: 10, paddingRight: 10, minHeight: 360 }}>

                  <Routes>
                    <Route path='/' element={<Dashboard />} />
                    <Route path='/docs' element={<AllDocsPage />} />
                    <Route path='/doc/:uuid' element={<DocViewerPage />} />
                    <Route path='/profile' element={<ProfilePage />} />
                    <Route path='*' element={<NotFound />} />
                    {
                      authState?.is_admin &&
                      <>
                        <Route path='/admin' element={<Admin />} />
                        <Route path='/admin/users' element={<UserPage />} />
                        <Route path='/admin/departments' element={<DepartmetPage />} />
                        <Route path='/admin/document-hierarchy' element={<DocumentHierarchy />} />
                        <Route path='/admin/document' element={<DocumentPage />} />
                        <Route path='/admin/footer' element={<FooterPage />} />
                      </>
                    }
                  </Routes>
                </Content>
              {/* </Layout> */}
            </Layout>
            <Footer style={{ textAlign: 'center', padding: '0px 15px 15px 15px', }}>
              <FooterComponent footer={menu?.footer} />
            </Footer>
          </Layout>
        )
      }
    </Router>
  )

}